// @need-translate
import {ReactNode, useCallback, useEffect, useState} from 'react';
import {t} from '../../common/getTranslations';
import {requestContext} from '../../common/requestContext';
import {
  ButtonV2Size,
  ButtonV2Variant,
} from '../../design-system/atoms/ButtonV2/ButtonV2.enum';
import {useDialog} from '../../dialog/useDialog.hook';
import {useLogin} from '../../user/useLogin.hook';

export function AskIsLoginChecker({children}: {children: ReactNode}) {
  const {isMobile, isAndroid, isIos} = requestContext.requestInfo.display;
  const {isLogin} = useLogin();

  // 구앱에서는 기존 카카오 CS로 이동하는데, 카카오측에서 우리 CRMS 페이지로 redirect 하고 있습니다. 이 경우 인증을 유지할 수 없어 비로그인 상태가 됩니다. 비로그인에도 문의는 가능하나 사용자에게 최신 버전으로 업데이트 하라는 가이드 메시지를 보여줘야 합니다.(기획 요청)
  const [isFromKakaoCS, setIsFromKakaoCS] = useState(false);
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setIsFromKakaoCS(
      searchParams.has('plmn') && searchParams.has('app_version')
    );
  }, []);

  const {DialogWrapper, Dialog, hideDialog, showDialog} = useDialog({
    isMobile,
  });

  const onClickAppUpdate = useCallback(() => {
    if (isIos) {
      window.location.href =
        'https://apps.apple.com/kr/app/%EC%B9%B4%EC%B9%B4%EC%98%A4%ED%8E%98%EC%9D%B4%EC%A7%80/id616643813';
    } else if (isAndroid) {
      window.location.href =
        'https://play.google.com/store/apps/details?id=com.kakao.page';
    }
  }, [isIos, isAndroid]);

  useEffect(() => {
    if (!isLogin) {
      showDialog();
    }
  }, [isLogin, showDialog]);

  if (!children) {
    return null;
  }

  return (
    <>
      {!isLogin && (
        <DialogWrapper>
          <Dialog.Dimmed />
          <Dialog.Title>
            {isFromKakaoCS
              ? '최신 버전으로 업데이트 후\n문의해주세요.' // 구앱의 카카오 redirect 는 글로벌에선 일어나지 않는 일이기 때문에 번역키 없이 보여줍니다
              : t('more_customer_cs_inquiry_tab_login_toast')}
          </Dialog.Title>
          <Dialog.List>
            <Dialog.Label>
              {isFromKakaoCS
                ? '현재 버전에서는 답변이 어려울 수 있습니다.'
                : t('more_customer_cs_inquiry_tab_login_toast_info')}
            </Dialog.Label>
            {/* android 구앱에서 카카오CS 용 웹뷰로 보여주는데 앱업데이트를 허용하지 않는 웹뷰라고 합니다. 앱업데이트 버튼은 비활성화 합니다.(기획 요청)) */}
            {isFromKakaoCS && isIos && (
              <Dialog.Button
                onClick={onClickAppUpdate}
                variant={ButtonV2Variant.Primary}
                size={ButtonV2Size.Small}
              >
                지금 업데이트 하기
              </Dialog.Button>
            )}
          </Dialog.List>
          <Dialog.BottomCombination>
            <Dialog.Button onClick={hideDialog}>
              {isFromKakaoCS
                ? t('common_close_button')
                : t('more_customer_cs_inquiry_tab_save_popup_confirm_button')}
            </Dialog.Button>
          </Dialog.BottomCombination>
        </DialogWrapper>
      )}
      {children}
    </>
  );
}
